import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleFetchFulfilled,
  handleFetchPending,
  handleFetchRejected,
  handleUpdatePending,
  handleUpdateRejected,
} from "redux/helpers/fetching"
import { fetchClient, updateClient } from "redux/features/client/clientThunk"
import {
  cancelEmailConfirmation,
  confirmEmail,
} from "redux/features/client/emailConfirmationThunk"
import {
  confirmPhone,
  cancelPhoneConfirmation,
} from "redux/features/client/phoneConfirmationThunk"

const clientAdapter = createEntityAdapter()
export const initialState = clientAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
  updateStatus: {
    isProgress: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchClient.pending, (state) => handleFetchPending(state))
      .addCase(fetchClient.rejected, (state) => handleFetchRejected(state))
      .addCase(fetchClient.fulfilled, (state, { payload }) => {
        clientAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
      .addCase(updateClient.pending, (state) => handleUpdatePending(state))
      .addCase(updateClient.rejected, (state) => handleUpdateRejected(state))
      .addCase(updateClient.fulfilled, (state, { payload }) => {
        clientAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
      .addCase(cancelEmailConfirmation.fulfilled, (state, { payload }) => {
        clientAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
      .addCase(confirmEmail.fulfilled, (state, { payload }) => {
        clientAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
      .addCase(cancelPhoneConfirmation.fulfilled, (state, { payload }) => {
        clientAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
      .addCase(confirmPhone.fulfilled, (state, { payload }) => {
        clientAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
  },
})

export const { selectById: selectClientById } = clientAdapter.getSelectors(
  (state: RootState) => state.features.client,
)

export const selectFetchStatus = (state: RootState) =>
  state.features.client.fetchStatus

export const selectUpdateStatus = (state: RootState) =>
  state.features.client.updateStatus

export default clientSlice.reducer
